
export const apiRoute = {
    login: "/api/account/login",
    upload: "/api/upload/",
    verificationValues: "/api/verificationValues",
    verificationBookingValues: "/api/verificationValues/booking",
    verificationShipmentValues: "/api/verificationValues/shipment",


    makeByVehicleType: "/api/verificationValues/makeByVehicleType?vehicleTypeId=",
    models: "/api/verificationValues/models?makeId=",
    container: "/api/container/search?term=",
    booking: "/api/booking/search?term=",
    addVehicle: "/api/vehicle",
    getVehicleInfo: "/api/vehicle/",
    reactivateVehicle: "/api/vehicle/reactivateVehicle",
    getFetchData: "/api/vehicle/page",
    getFetchDataExcel: "/api/vehicle/excel",
    getFetchExcelContainer: "/api/container/excel?Container=",
    getContainerCount: "/api/container/count",

    getVehicleCount: "/api/vehicle/count",
    getManage: '/api/',
    getUserData: '/api/user/all',
    getLogsData: '/api/log/page',
    updateDeleteAddManage: "/api/",
    logout: "/api/account/logout",
    changeAccountPassword: "/api/account/changePassword",
    changeAccountPasswordClient:"/api/account/changePasswordClient",
    consignee: "/api/consignee/search?term=",
    consigneeDock: "/api/consigneeDock/search?term=",
    brokerSearch: "/api/broker/search?term=",
    pushEmailClientSI: "/api/task/pushEmailClientSI",
    pushEmailCompanySI: "/api/task/pushEmailCompanySI",
    pushEmailSIAll: "/api/task/pushEmailSIAll",
    client: "/api/client/search?term=",
    transportCompanySearch: "/api/transportCompany/search?term=",
    pickupTerminalSearch: "/api/pickupTerminal/search?term=",
    returnTerminalSearch: "/api/returnTerminal/search?term=",
    destinationSearch: "/api/destination/search?term=",
    portLoadingSearch: "/api/portLoading/search?term=",
    shippingLineSearch: "/api/shippingLine/search?term=",
    makeSearch: "/api/make/search?term=",
    modelSearch: "/api/model/search?term=",
    vehicleTypeSearch: "/api/vehicleType/search?term=",
    getAllSettings: "/api/settings/all",
    


    settingsViewInitial: "/api/settings/verificationValues",
    vehiclesMobile: "/api/clientView/vehiclesMobile",

    clientViewInitial: "/api/clientView/verificationValues"


}



// Read base URL from environment. CRA requires env vars to start with REACT_APP_
// Use REACT_APP_BASE_URL; fall back to the previous production host if not set.
export const baseUrl = process.env.REACT_APP_BASE_URL ;